export const REPRINT_CERTIFICATE_TYPE = "REPRINT_CERTIFICATE_TYPE";
export const REPRINT_CERTIFICATE_TYPE_SUCCESS =
  "REPRINT_CERTIFICATE_TYPE_SUCCESS";
export const REPRINT_CERTIFICATE_TYPE_ERROR = "REPRINT_CERTIFICATE_TYPE_ERROR";
export const REPRINT_CERTIFICATE_TYPE_CLEAR_DATA =
  "REPRINT_CERTIFICATE_TYPE_CLEAR_DATA";
